import { Component } from '@angular/core';
import { EMDMICONS } from '../../../../common/constants/icon-packs.constant';
import { IntegrationLogService } from '../../service/integration-log.services';
import { Router } from '@angular/router';
import { GridDataResult, PageChangeEvent, PagerType } from '@progress/kendo-angular-grid';
import { CommonService } from '../../../../common/service/common.service';
import { SortDescriptor } from '@progress/kendo-data-query';

@Component({
  selector: 'app-integration-log',
  standalone: false,
  templateUrl: './integration-log.component.html',
  styleUrl: './integration-log.component.scss'
})
export class IntegrationLogComponent {
  infoNote: string = 'Status : 0 not processed, 1 sucess, 2 Error Processing, 3 Ignored';
  type: PagerType = "numeric";
  integrationLogList: GridDataResult = { data: [], total: 0 };
  statusFilter: string = '-1';
  pageSize: number = 15;
  skip = 0;
  tabSelected = 'All';
  searchText = '';
  advancedFilter: string = '';
  searchStringForQuery: string = '';
  advanceFilterDto: any = null;

  iconPacks = EMDMICONS;

  //Status-> 0 To processed, 1 sucess, 2 Error Processing, 3 Ignored]
  statusList = ['To Process', 'Success!', 'Error', 'Ignored!']
  requestPopup: boolean = false;

  cLog: any;
  tital: string = '';
  cDBLog: any;
  cJsonText: any;
  shortBy: any = 'id';
  shortType: string = 'desc';
  sort: SortDescriptor[] = [];
  filterId:string = 'CSMRT_BO_IntegrationLog_integration_log_filter';
  constructor(private helpService: IntegrationLogService, private router: Router,
    private commonService: CommonService
  ) { }

  ngOnInit() {
    this.oldAdvanceFilterResponse = localStorage.getItem(this.filterId) ? JSON.parse(localStorage.getItem(this.filterId) || '{}') : null;
    this.advanceFilterDto = this.oldAdvanceFilterResponse?.filterEvent?.advanceFilterDto || null;

    this.getIntegrationLogs();
    // this.MaterialMaster()
  }
  public pageChange({ skip, take }: PageChangeEvent): void {
    this.skip = skip;
    this.pageSize = take;
    this.getIntegrationLogs();

  }
  navigateTo(url: string, queryParams: any = null) {
    this.router.navigate([url], { queryParams: queryParams });
  }
  changeTab(tab: string) {
    this.shortBy = 'id';
    this.shortType = 'desc';
    this.skip = 0;
    this.pageSize = 10;
    this.tabSelected = tab;
    this.statusFilter = tab == 'All' ? '-1' : this.statusList.indexOf(tab).toString();
    this.advancedFilter = '';
    this.integrationLogList = { data: [], total: 0 };
    this.getIntegrationLogs();
  }
  getIntegrationLogs(preventLoader: boolean = false) {
    let filers = {
      "quickFilter": this.searchText,
      "pageStartIndex": this.skip,
      "pageSize": this.pageSize,
      "orderBy": this.shortBy,//id defailt
      "sort": (this.shortType || "desc").toLocaleUpperCase(),
      "statusFilter": this.statusFilter,
      "advancedFilter": '',
      "advanceFilterDto": this.advanceFilterDto,
      "preventLoader": preventLoader || false

    }
    this.helpService.GetIntegrationLogs(filers).subscribe({
      next: (res: any) => {
        this.integrationLogList.data = res;
        if (res.length > 0) {
          this.integrationLogList.total = res[0].count;
        }

      },
      error: (err) => { }
    });
  }

  oldAdvanceFilterResponse: any = null;
  filterCustomData(event: any) {
    this.oldAdvanceFilterResponse = event;

    this.advancedFilter = event.filterEvent?.advanceFilterResponse?.searchString;
    this.searchStringForQuery = event.filterEvent?.advanceFilterResponse?.searchStringForQuery;
    this.searchText = event.searchValue;
    this.advanceFilterDto = event.filterEvent?.advanceFilterDto || null;
    this.integrationLogList = { data: [], total: 0 };
    this.skip = 0;
    this.getIntegrationLogs();
  }

  openCloseRequestPopup(type: string = 'new', log: any = null) {
    this.cLog = null;
    this.cDBLog = null;
    this.tital = "New Process Content";
    this.cJsonText = null;
    if (type == 'old') {
      this.tital = "Request '" + log.id + "' content ";
      this.cLog = log;
      this.GetProcessContentDetailsById(log.id);
    }
    this.requestPopup = !this.requestPopup;
  }

  runProcess(data: any) {
    if (confirm("This action will reprocess this file, do you want to continue?")) {
      this.GetProcessContentDetailsById(data.id, true);
    }
  }

  clickProcess() {
    if (this.cDBLog) {
      this.ProcessContent();
    } else {
      this.MaterialMaster()
    }
  }

  reProcess() {
    if (confirm("This action will reprocess all files in the displayed list, do you want to continue?")) {

      let ids = this.integrationLogList.data.map((x: any) => x.id);
      this.helpService.ReProcess(ids).subscribe({
        next: (res: any) => {
          this.getIntegrationLogs();
        },
        error: (err) => {
          this.getIntegrationLogs();

        }
      });
    }
  }

  ProcessContent(preventLoader = false) {

    let body = {
      "id": this.cDBLog?.id || 0,
      "jsonText": this.cJsonText ? (this.cJsonText) : this.cDBLog.jsonText,
      "processedOn": this.cDBLog.processedOn,
      "processedStatus": this.cDBLog.processedStatus,
      "requestId": this.cDBLog.requestId,
      "errorMessage": this.cDBLog.errorMessage,
      "savedOn": this.cDBLog.savedOn,
      "actionType": this.cDBLog.actionType,
      "materialMasterName": this.cDBLog.materialMasterName,
      "processingCounter": this.cDBLog.processingCounter,
      "preventLoader": preventLoader || false
    }

    this.helpService.ProcessContent(body).subscribe({
      next: (res: any) => {
        this.getIntegrationLogs(preventLoader);
        this.requestPopup = false;
        this.cJsonText = null;
        this.cDBLog = null;
        // this.commonService.showNotificationMessage('Run processed successfully', 'success',);
      },
      error: (err) => {
        this.getIntegrationLogs();
        this.requestPopup = false;
        this.cJsonText = null;
        this.cDBLog = null;
        // this.commonService.showNotificationMessage('Error processing the request', 'error',);
      }
    });
  }

  MaterialMaster() {
    this.helpService.MaterialMaster(this.cJsonText || '').subscribe({
      next: (res: any) => {
        // this.commonService.showNotificationMessage('Request processed successfully', 'success',);
        this.requestPopup = false;
        this.cDBLog = null;
        this.cLog = null;
        this.cJsonText = null;
        this.getIntegrationLogs();
      },
      error: (err) => {
        this.requestPopup = false;
        this.cDBLog = null;
        this.cLog = null;
        this.cJsonText = null;
        this.getIntegrationLogs();

        // this.commonService.showNotificationMessage('Error processing the request', 'error',);
      }
    });
  }
  GetProcessContentDetailsById(id: number, runProcess: boolean = false, preventLoader: boolean = false) {
    this.helpService.GetProcessContentDetailsById({ id: id }).subscribe({
      next: (res: any) => {
        this.cDBLog = res;
        if (runProcess) {
          this.ProcessContent(preventLoader);
          return;
        }
        this.cJsonText = this.cDBLog.jsonText
      },
      error: (err) => { }
    });
  }

  sortChange(event: any) {
    if (event[0]?.dir) {
      this.sort = event;
      this.shortBy = event[0]?.field;
      this.shortType = event[0]?.dir;
    }
    else {
      this.sort = [];
      this.shortBy = 'id';
      this.shortType = 'desc';
    }

    this.skip = 0;
    this.getIntegrationLogs();
  }
}
